import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

// Envoie une vue de page (page_view) à Google Analytics à chaque changement
// d'URL. C'est ce qui permet à chaque URL SEO — ville / quartier / spécialité
// (ex. /rabat/agdal/cardiologue) — d'être comptée comme une vue distincte dans
// GA4, y compris lors des navigations sans rechargement.
export default function RouteAnalytics() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;

    // La toute première vue est déjà envoyée automatiquement par Google Analytics
    // au chargement de la page. On saute donc ce premier rendu pour éviter un doublon
    // (arrivée directe depuis un moteur de recherche sur une URL SEO).
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // On laisse le temps à la page de définir son <title> avant d'envoyer la vue,
    // pour que GA reçoive le bon titre.
    const timer = window.setTimeout(() => {
      trackPageView(path);
    }, 0);

    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  return null;
}